<template>
  <TableBodyRow
    :thead="thead"
    class="repfloptblrow gw_table_body_row_hoverable gw_hvr gw_hvr_disabled"
  >
    <TableBodyCell
      thKey="name"
      class="gw_table_body_cell_sticky"
      style="min-width: var(--name-cell-width)"
    >
      <slot name="name">
        <StudyReportsGroupItemTitle
          :item="item"
          :colorDefault="true"
        />
        <StudyReportsLinks
          v-if="hasLinks"
          :namespace
          :item="item"
          :flopGroup="item.flopGroup"
          :flopBoard="flopBoard"
          :linkParams="linkParams"
          class="gw_hvr_content"
          style="
            z-index: 6;
            position: absolute;
            right: 0.25rem;
            gap: 0;
            height: 2rem;
            --2nd-child-margin: -0.5rem;
            --flex-direction: column;
          "
        />
        <div
          v-if="item.ratio"
          class="totals-ratio ml-auto text-small my-auto weight_500"
        >
          {{ numFixed(item.ratio * 100, 1) }}%
        </div>
      </slot>
    </TableBodyCell>
    <TableBodyCell
      thKey="strategy"
      style="--padding-td: 0 0.125rem 0 0"
    >
      <div
        style="height: 100%; width: 100%; rotate: 180deg"
        :style="
          item.backgrounds.counts
            ? item.backgrounds.counts
            : useHex
              ? item.backgrounds.horizontal_hex
              : item.backgrounds.horizontal_var
        "
      ></div>
    </TableBodyCell>

    <TableBodyCell
      v-for="(aa, key, index) in item.tdActions"
      :ref="`cell_${aa.key + index}`"
      :key="aa.key + index"
      :thKey="aa.key"
      style="--padding-td: 0 0 0 0; overflow: hidden"
      @mouseleave="$emit('mouseleave:cell')"
      @mouseenter="
        $emit('mouseenter:cell', {
          el: $refs[`cell_${aa.key + index}`],
          action: aa.action,
        })
      "
    >
      <div
        style="height: 100%"
        :class="[aa.action.css_class]"
        :style="`width: ${aa.action.frequency * 100}%; ${
          useHex ? `background: ${aa.action.hex}` : ''
        }`"
      ></div>
      <div
        class="position-absolute w-100 f-center"
        style="text-shadow: var(--text-shadow_drop)"
        :style="`font-size: ${aa.solved_action_count ? '0.85rem' : '1rem'};`"
      >
        {{
          aa.solved_action_count
            ? `${aa.solved_action_count} (${numFixed(aa.solved_action_count_percentage * 100, 1)}%)`
            : aa.action.isNa
              ? '-'
              : numFixedUnit(aa.action.frequency * 100, 'strategy')
        }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-for="(ii, index) in thEvEqErq"
      :key="ii.key + index"
      :thKey="ii.key"
      class="reptable_coloredcell"
      style="justify-content: center"
      :class="`player_${ii.player}`"
      :style="`--clr-value: var(${item[ii.player][`${ii.valKey}Clr`]});--nrm-percent:${
        item[ii.player][`${ii.valKey}_normalized`] * 100
      }%;
      `"
    >
      <div
        class="text-center"
        style="line-height: 0.8"
        v-html="
          ii.valKey === 'ev'
            ? item[ii.player].no_data
              ? ''
              : getEvHtml({
                  ...bettingInfo,
                  ev: item[ii.player][ii.valKey],
                })
            : item[ii.player].no_data
              ? ''
              : numFixed(item[ii.player][ii.valKey] * (ii.increment || 1), ii.decimals)
        "
      />
    </TableBodyCell>
    <TableBodyCell
      style="order: 99; --padding-td: 0"
      class="role_spacer"
    >
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import StudyReportsLinks from '@/components/Study/StudyReportsLinks'
import StudyReportsGroupItemTitle from '@/components/Study/StudyReportsGroupItemTitle'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'RepTableRow',

  components: {
    TableBodyRow,
    TableBodyCell,
    StudyReportsLinks,
    StudyReportsGroupItemTitle,
  },
  mixins: [table_mix, float_mix],
  props: {
    namespace: { required: true, type: String },
    item: Object,
    index: Number,
    thead: Object,
    useHex: Boolean,
    thActions: Object,
    thEvEqErq: Object,
    showBetsIn: String,
    grouping: String,
    flopBoard: String,
    hasLinks: Boolean,
    scrolledLeft: Boolean,
    bettingInfo: Object,
    linkParams: Object,
  },
  emits: ['mouseenter:cell', 'mouseleave:cell'],
  data() {
    return {}
  },
}
</script>
